import { config } from "../../config";
import { Notification } from "./data-types";

type NotificationsResult = {
    data?: Array<Notification>
    meta?: { total: number }
    error?: string
}

type NotificationsCountResult = { 
    data?: {
        various: number
        messages_cafe: number
        messages_salon: number 
    }
    error?: string
} 


export const generalNotifications = async ( 
    offset: number, 
    limit: number, 
    token?: string
): Promise<NotificationsResult> => {
    try {
        const authHeaders: {[key: string]: string} = {}
        if (token) {
            authHeaders['token'] = token!
        }

        const params: any = {
            offset,
            limit,
        }

        const res = await fetch(`${config.api.urlV1}/user/notifications/various/?${new URLSearchParams(params).toString()}`, {
            method: 'GET',
            headers: {
                ...authHeaders,
                'Content-type': 'application/json',
            },
        })

        if (res.status !== 200) {
            const body = await res.json()

            return {
                error: body.error?.title
            }
        }

        const body: { data: Array<Notification>, meta: { total: number } } = await res.json()

        return {
            data: body.data,
            meta: body.meta,
        }
    } catch (e) {
        console.log(e)
        return {
            error: e as string
        }
    }
}

export const messagesNotifications = async ( 
    offset: number, 
    limit: number, 
    token?: string
): Promise<NotificationsResult> => {
    try {
        const authHeaders: {[key: string]: string} = {}
        if (token) {
            authHeaders['token'] = token!
        }

        const params: any = {
            offset,
            limit,
        }

        const res = await fetch(`${config.api.urlV1}/user/notifications/messages/?${new URLSearchParams(params).toString()}`, {
            method: 'GET',
            headers: {
                ...authHeaders,
                'Content-type': 'application/json',
            },
        })

        if (res.status !== 200) {
            const body = await res.json()

            return {
                error: body.error?.title
            }
        }

        const body: { data: Array<Notification>, meta: { total: number } } = await res.json()

        return {
            data: body.data,
            meta: body.meta,
        }
    } catch (e) {
        console.log(e)
        return {
            error: e as string
        }
    }
}

export const notificationsCount = async ( 
    token: string
): Promise<NotificationsCountResult> => {
    try {
        const authHeaders: {[key: string]: string} = {}
        if (token) {
            authHeaders['token'] = token!
        }

        const res = await fetch(`${config.api.urlV1}/user/notifications/unreads/`, {
            method: 'GET',
            headers: {
                ...authHeaders,
                'Content-type': 'application/json',
            },
        })

        if (res.status !== 200) {
            const body = await res.json()

            return {
                error: body.error?.title
            }
        }

        const body: { various: number, messages_cafe: number, messages_salon: number } = await res.json()

        return {
            data: body
        }
    } catch (e) {
        console.log(e)
        return {
            error: e as string
        }
    }
}